module.exports = __webpack_public_path__ + "static/media/iphone XR banner2.36cfd667.jpg";